__turbopack_context__.v({
  "footer": "BriefContactStatusModalMobile-module-scss-module__P1OiAW__footer",
});
